<template>
  <div class="detail-page">
    <div v-if="loading" class="errText"></div>
    <div v-else-if="errMsg" class="errText">{{ errMsg }}</div>
  </div>
</template>

<script>
import { receive } from '@/api/xibMaintain'
import {
  buildReceiveParams,
  buildSuccessQuery,
  getReceiveErrorMessage,
  isReceiveSuccess,
} from './utils/successQuery'

const RECEIVE_ERROR_KEY = 'xibMaintainReceiveError'

export default {
  name: 'xibMaintainWxDetail',
  data() {
    return {
      loading: true,
      errMsg: '',
    }
  },
  created() {
    this.handleReceive()
  },
  methods: {
    redirectReceiveFail(message) {
      sessionStorage.setItem(RECEIVE_ERROR_KEY, message || '领取失败')
      this.$router.replace({ path: '/luyuanXibMaintain' })
    },
    async handleReceive() {
      try {
        const { urlToken } = this.$route.query
        if (urlToken) {
          sessionStorage.setItem('luyuanToken', urlToken)
        }
        this.loading = true
        const { gradeNum } = this.$route.query
        const res = await receive(
          buildReceiveParams(
            {
              gradeNum,
              appId: this.$route.query.appId,
              openId: this.$route.query.openId,
            },
            1,
          ),
        )
        if (!res || res.code !== 0) {
          this.redirectReceiveFail(getReceiveErrorMessage(res))
          return
        }
        if (!isReceiveSuccess(res.data)) {
          this.redirectReceiveFail(getReceiveErrorMessage(res))
          return
        }
        this.$router.replace({
          path: '/luyuanXibMaintainSuccessResultPage',
          query: buildSuccessQuery(res.data, 1),
        })
      } catch (e) {
        console.log(e)
        this.loading = false
        this.redirectReceiveFail(getReceiveErrorMessage(e, '领取失败'))
      }
    },
  },
}
</script>

<style lang="less" scoped>
.detail-page {
  min-height: 100vh;
  background: #fefaf2;
}

.errText {
  padding: 80px 20px;
  text-align: center;
  font-size: 14px;
  color: #666666;
}
</style>
